module.exports = __webpack_public_path__ + "85c0689d148fc47803506b07afd49224.svg";